import { GlobalStore } from "store/global/GlobalStore";

export const getIsUserConnected = () => GlobalStore.getRawState().address !== "";
